// src/redux/slices/challengeSlice.ts
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchChallengesAPI } from "@/services/api/Challanges";

// Async thunk
export const fetchChallenges = createAsyncThunk(
  "challenges/fetchChallenges",
  async ({ search = "", difficultyLevel = "", pageNo = 1, perPage = 10 }: any = {}, { rejectWithValue }) => {
    try {
      const response = await fetchChallengesAPI(search, difficultyLevel, pageNo, perPage);
      // Handle both results (tags-style) and content (page-style)
      // Check res.data.data.results, res.data.data.content, etc.
      const data = response?.data?.results || response?.data?.content || response?.data || [];
      return {
        results: Array.isArray(data) ? data : [],
        totalRecord: response?.data?.totalRecord || 0,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Error fetching challenges");
    }
  }
);

const challengeSlice = createSlice({
  name: "challenges",
  initialState: {
    challenges: [],
    totalRecords: 0,
    loading: false,
    error: null as string | null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchChallenges.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchChallenges.fulfilled, (state, action) => {
        state.loading = false;
        state.challenges = action.payload.results as any;
        state.totalRecords = action.payload.totalRecord;
        console.log(action.payload);

      })
      .addCase(fetchChallenges.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default challengeSlice.reducer;